import { get } from "../../service/api";

const GetPermissions = async () => {
  try {
    const response = await get(`/admin/permissions`);
    return response;
  } catch (error) {
    console.error("Error getPermissions:", error);
    throw error;
  }
};

export default GetPermissions;
